import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LoginApp } from "~/apps/LoginApp";
import { initSentry } from "~/lib/sentry";

initSentry();

const root = createRoot(document.getElementById("react")!);

root.render(
  <StrictMode>
    <LoginApp />
  </StrictMode>,
);
